export default __webpack_public_path__ + "static/day-11-cf8cb2eb3d6eb4513457546aa362ef7c.gif";